import { Box, Link, Theme } from '@mui/material';
import React, { memo } from 'react';
import { Icon } from '@alycecom/ui';

const styles = {
  urlBlock: {
    px: 5,
    py: 1,
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    border: ({ palette }: Theme) => `1px solid ${palette.divider}`,
    borderRadius: '5px',
    fontSize: 16,
    color: ({ palette }: Theme) => palette.link.main,
  },
  url: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  copyButton: {
    borderRadius: '5px',
  },
  icon: {
    ml: 1,
    fontSize: 14,
  },
} as const;

export interface ITangoCardUrlProps {
  url: string;
}

const TangoCardUrl = ({ url }: ITangoCardUrlProps): JSX.Element => (
  <Box display="flex">
    <Box sx={styles.urlBlock} data-testid="RedeemPage.Url.Value">
      <Link href={url} target="_blank" rel="noopener noreferrer" sx={styles.url}>
        {url}
      </Link>
      <Icon icon="external-link" sx={styles.icon} />
    </Box>
  </Box>
);

export default memo(TangoCardUrl);
